module.exports = __webpack_public_path__ + "static/media/laundry_bundle_icon.7641ed0b.svg";